export enum MASK_VARIABLES {
  CIRCLE_SCALE = '--circleScale',
  TEXT_MASK_X = '--textMaskX',
  TEXT_MASK_Y = '--textMaskY',
}
